import { render, staticRenderFns } from "./ModifyWithdrawMethodModal.vue?vue&type=template&id=5231464c&scoped=true"
import script from "./ModifyWithdrawMethodModal.vue?vue&type=script&lang=js"
export * from "./ModifyWithdrawMethodModal.vue?vue&type=script&lang=js"
import style0 from "./ModifyWithdrawMethodModal.vue?vue&type=style&index=0&id=5231464c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5231464c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5231464c')) {
      api.createRecord('5231464c', component.options)
    } else {
      api.reload('5231464c', component.options)
    }
    module.hot.accept("./ModifyWithdrawMethodModal.vue?vue&type=template&id=5231464c&scoped=true", function () {
      api.rerender('5231464c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ezpay/data/components/Modal/ModifyWithdrawMethodModal.vue"
export default component.exports